import "./Projects.module.css";
import Header from "@/reusable_sections/Header";
import ProvenImpacts from "./sections/ProvenImpacts";
import TheTeamCollaborators from "./sections/TheTeamCollaborators";
import TheSavoryStory from "./sections/TheSavoryStory";
import BrandFootnote from "@/reusable_sections/Footer";
import Portfolio from "./sections/Portfolio";
export default function ProjectsPage() {
  return <div>
      <Header />
      <ProvenImpacts />
      <TheSavoryStory />
      <Portfolio />
      <TheTeamCollaborators />
      <BrandFootnote />
    </div>;
}